"use client";

import { MutationOptions, useMutation } from "@tanstack/react-query";
import {
  createNextNavigation,
  createPreviousNavigation,
  createSpecificStepNavigation,
} from "@/src/api/services/navigation";
import { runAction, runApiCall } from "@/src/api/services/action";
import { useContextStore } from "@/src/stores/useContextStore";
import { updateProcessInstance } from "@/src/api/services/processInstance";
import { useProcessInstanceStore } from "@/src/stores/useProcessInstanceStore";
import { useTimeSpentStore } from "@/src/stores/useTimeSpentStore";

export const scrollToTop = (smooth = false) => {
  setTimeout(() => {
    const start = Date.now();
    const node = document.querySelector(".MuiFormHelperText-root.Mui-error");
    node?.scrollIntoView({
      block: "center",
      behavior: smooth ? "smooth" : "instant",
    });
    if (!node) {
      window.scrollTo({ top: 0, behavior: smooth ? "smooth" : "instant" });
    }
    const timeSpent = Date.now() - start;
    console.log("SCROLL INFO", { timeSpent, node });
  }, 0);
};

export const useApiCall = (
  props?: MutationOptions<any, any, any>,
  apiCall = false,
) => {
  return useMutation({
    mutationFn: apiCall ? runApiCall : runAction,
    onSuccess: (data, variables, context) => {
      props?.onSuccess?.(data, variables, context);
    },
    onError: (error) => {
      console.error(error);
    },
    onMutate: props?.onMutate,
  });
};
export const useNextNavigation = (props?: MutationOptions<any, any, any>) => {
  const setProcessInstance = useProcessInstanceStore(
    (state) => state.setProcessInstance,
  );
  const { replaceVariablesObject } = useContextStore();
  return useMutation({
    mutationFn: createNextNavigation,
    onSuccess: (data, variables, context) => {
      console.log("useNextNavigation onSuccess", { data, variables, context });
      replaceVariablesObject(data.contextInstance.variables);
      useTimeSpentStore.getState().resetStartTime();
      setProcessInstance(data);
      props?.onSuccess?.(data, variables, context);
      scrollToTop();
    },
    onMutate: props?.onMutate,
  });
};
export const usePreviousNavigation = (
  props?: MutationOptions<any, any, any>,
) => {
  const setProcessInstance = useProcessInstanceStore(
    (state) => state.setProcessInstance,
  );
  const { replaceVariablesObject } = useContextStore();
  return useMutation({
    mutationFn: createPreviousNavigation,
    onSuccess: (data, variables, context) => {
      console.log("usePreviousNavigation onSuccess", {
        data,
        variables,
        context,
      });
      replaceVariablesObject(data.contextInstance.variables);
      useTimeSpentStore.getState().resetStartTime();
      setProcessInstance(data);
      props?.onSuccess?.(data, variables, context);
      scrollToTop();
    },
    onMutate: props?.onMutate,
  });
};
export const useSpecificStepNavigation = (
  props?: MutationOptions<any, any, any>,
) => {
  const setProcessInstance = useProcessInstanceStore(
    (state) => state.setProcessInstance,
  );
  const { replaceVariablesObject } = useContextStore();
  return useMutation({
    mutationFn: createSpecificStepNavigation,
    onSuccess: (data, variables, context) => {
      console.log("useSpecificStepNavigation onSuccess", {
        data,
        variables,
        context,
      });
      replaceVariablesObject(data.contextInstance.variables);
      useTimeSpentStore.getState().resetStartTime();
      setProcessInstance(data);
      props?.onSuccess?.(data, variables, context);
      scrollToTop();
    },
    onMutate: props?.onMutate,
  });
};

export const useUpdateProcessInstance = (
  props?: MutationOptions<any, any, any>,
) => {
  return useMutation({
    mutationFn: updateProcessInstance,
    onSuccess: (data, variables, context) => {
      console.log("useUpdateProcessInstance onSuccess", {
        data,
        variables,
        context,
      });
      props?.onSuccess?.(data, variables, context);
    },
    onMutate: props?.onMutate,
  });
};
